import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { CardSavedFilter, CardSavedFilterCreate, CardSavedFilterEnvelope, CardSavedFilterListEnvelope } from '../models/card-saved-filter.model';

@Injectable({ providedIn: 'root' })
export class CardSavedFilterService extends AbstractService<CardSavedFilter> {

  getURLBase(): string {
    return '/card-saved-filter';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: CardSavedFilter): void {
    delete obj?._id;
  }

  preUpdate(obj: CardSavedFilter): void {
  }

  getByFunnel(idFunnel: string): Observable<CardSavedFilterListEnvelope> {
    return super.get(`/funnel/${idFunnel}`);
  }

  save(body: CardSavedFilterCreate): Observable<CardSavedFilterEnvelope> {
    return super.post('/create', body);
  }

}
